import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("co_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    // Skip auto-logout on business-logic 401s (login attempts, password change, etc.)
    const skipAutoLogout = url.includes("/auth/login") || url.includes("/auth/change-password");
    if (
      err?.response?.status === 401 &&
      !skipAutoLogout &&
      !window.location.pathname.startsWith("/login")
    ) {
      localStorage.removeItem("co_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (path) => `${API_BASE}/files/${path}`;

export default api;
